import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, ShoppingBagIcon, TrashIcon } from 'lucide-react';
import { useCart } from '../context/CartContext';
const Cart = () => {
  const {
    cartItems,
    removeFromCart,
    getTotalPrice
  } = useCart();
  const subtotal = getTotalPrice();
  const shipping = subtotal > 0 ? 350 : 0;
  const total = subtotal + shipping;
  if (cartItems.length === 0) {
    return <div className="bg-[#f8f9f4] min-h-screen w-full py-16" data-id="element-723">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-724">
          <div className="max-w-2xl mx-auto text-center" data-id="element-725">
            <div className="bg-white rounded-xl shadow-md p-12" data-id="element-726">
              <div className="flex justify-center mb-6" data-id="element-727">
                <div className="bg-[#e8f5e9] p-4 rounded-full" data-id="element-728">
                  <ShoppingBagIcon className="h-12 w-12 text-[#2e7d32]" data-id="element-729" />
                </div>
              </div>
              <h1 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-730">
                Your cart is empty
              </h1>
              <p className="text-gray-600 mb-8" data-id="element-731">
                Looks like you haven't added any products to your cart yet.
              </p>
              <Link to="/products" className="inline-flex items-center justify-center bg-[#2e7d32] hover:bg-[#1b5e20] text-white px-6 py-3 rounded-lg font-medium transition-colors duration-300" data-id="element-732">
                <ArrowLeftIcon className="mr-2 h-4 w-4" data-id="element-733" />
                Continue Shopping
              </Link>
            </div>
          </div>
        </div>
      </div>;
  }
  return <div className="bg-[#f8f9f4] min-h-screen w-full py-16" data-id="element-734">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-735">
        <div className="max-w-7xl mx-auto" data-id="element-736">
          <h1 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-737">
            Your Shopping Cart
          </h1>
          <div className="flex flex-col lg:flex-row gap-8" data-id="element-738">
            {/* Cart items */}
            <div className="flex-grow" data-id="element-739">
              <div className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-740">
                <div className="p-6" data-id="element-741">
                  <div className="flex justify-between items-center mb-6" data-id="element-742">
                    <h2 className="text-xl font-semibold text-gray-900" data-id="element-743">
                      {cartItems.length}{' '}
                      {cartItems.length === 1 ? 'Item' : 'Items'}
                    </h2>
                  </div>
                  <div className="divide-y divide-gray-200" data-id="element-744">
                    {cartItems.map(item => <div key={item.product.id} className="py-6 flex flex-col sm:flex-row" data-id="element-745">
                        <div className="flex-shrink-0 w-full sm:w-24 h-24 bg-gray-100 rounded-md overflow-hidden mb-4 sm:mb-0" data-id="element-746">
                          <img src={item.product.image} alt={item.product.name} className="w-full h-full object-cover" onError={e => {
                        e.currentTarget.src = 'https://images.unsplash.com/photo-1595981267035-7b04ca84a82d?q=80&w=150&auto=format&fit=crop';
                      }} data-id="element-747" />
                        </div>
                        <div className="flex-grow sm:ml-6" data-id="element-748">
                          <div className="flex justify-between" data-id="element-749">
                            <div data-id="element-750">
                              <h3 className="text-base font-medium text-gray-900" data-id="element-751">
                                {item.product.name}
                              </h3>
                              <p className="mt-1 text-sm text-gray-500 line-clamp-1" data-id="element-752">
                                {item.product.description}
                              </p>
                            </div>
                            <p className="text-base font-medium text-gray-900" data-id="element-753">
                              {item.product.price}
                            </p>
                          </div>
                          <div className="flex justify-between items-center mt-4" data-id="element-754">
                            <div className="flex items-center border border-gray-300 rounded-md" data-id="element-755">
                              <span className="px-4 py-2 text-gray-900" data-id="element-756">
                                {item.quantity}
                              </span>
                            </div>
                            <button onClick={() => removeFromCart(item.product.id)} className="text-gray-500 hover:text-red-500" data-id="element-757">
                              <TrashIcon className="h-5 w-5" data-id="element-758" />
                            </button>
                          </div>
                        </div>
                      </div>)}
                  </div>
                </div>
              </div>
              <div className="mt-8" data-id="element-759">
                <Link to="/products" className="inline-flex items-center text-[#2e7d32] font-medium hover:text-[#1b5e20]" data-id="element-760">
                  <ArrowLeftIcon className="mr-2 h-4 w-4" data-id="element-761" />
                  Continue Shopping
                </Link>
              </div>
            </div>
            {/* Order summary */}
            <div className="w-full lg:w-96" data-id="element-762">
              <div className="bg-white rounded-xl shadow-md p-6 sticky top-24" data-id="element-763">
                <h2 className="text-lg font-semibold text-gray-900 mb-6" data-id="element-764">
                  Order Summary
                </h2>
                <div className="space-y-4" data-id="element-765">
                  <div className="flex justify-between" data-id="element-766">
                    <p className="text-gray-600" data-id="element-767">Subtotal</p>
                    <p className="text-gray-900 font-medium" data-id="element-768">
                      KSh {subtotal.toLocaleString()}
                    </p>
                  </div>
                  <div className="flex justify-between" data-id="element-769">
                    <p className="text-gray-600" data-id="element-770">Shipping</p>
                    <p className="text-gray-900 font-medium" data-id="element-771">
                      KSh {shipping.toLocaleString()}
                    </p>
                  </div>
                  <div className="border-t border-gray-200 pt-4 flex justify-between" data-id="element-772">
                    <p className="text-gray-900 font-semibold" data-id="element-773">Total</p>
                    <p className="text-gray-900 font-semibold" data-id="element-774">
                      KSh {total.toLocaleString()}
                    </p>
                  </div>
                </div>
                <button className="mt-6 w-full bg-[#2e7d32] hover:bg-[#1b5e20] text-white py-3 px-4 rounded-lg transition-colors duration-300" data-id="element-775">
                  Proceed to Checkout
                </button>
                <div className="mt-6 text-xs text-gray-500 text-center" data-id="element-776">
                  <p data-id="element-777">Taxes calculated at checkout</p>
                  <p className="mt-1" data-id="element-778">Free shipping on orders over KSh 5,000</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default Cart;